var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618873312"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Layer 1",
    x: -0.0012207,
    y: 0.000640869,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00BF63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.9338 18.3632L16.8766 13.2533C16.5809 13.0843 16.2456 12.9966 15.9049 12.9992C15.5642 13.0018 15.2304 13.0946 14.9372 13.2681C14.6516 13.4315 14.4143 13.6675 14.2494 13.9523C14.0846 14.237 13.998 14.5603 13.9985 14.8894V25.1091C13.998 25.4381 14.0846 25.7614 14.2494 26.0462C14.4143 26.3309 14.6516 26.567 14.9372 26.7303C15.2304 26.9038 15.5643 26.9965 15.9049 26.9991C16.2456 27.0017 16.5808 26.9141 16.8766 26.7451L25.9338 21.6353C26.2259 21.4735 26.4693 21.2364 26.6388 20.9487C26.8084 20.661 26.8978 20.3332 26.8978 19.9992C26.8978 19.6653 26.8084 19.3375 26.6388 19.0498C26.4693 18.7621 26.2259 18.525 25.9338 18.3632Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.5d3675c75951ddc7b92175f4d64c0c7c.svg";
export { ForwardRef as ReactComponent };